import {
  Unit_instance3kz1zqli6gr1r as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  HttpResponseValidator2d6ie1tmzg8fi as HttpResponseValidator,
  get_ExpectSuccessAttributeKey20jj5fup38v1g as get_ExpectSuccessAttributeKey,
} from './HttpCallValidator.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { save1hc0jjdmqj6mp as save } from '../call/SavedCall.mjs';
import { bodyAsText193cd91fn5h1t as bodyAsText } from '../statement/HttpResponse.mjs';
import { MalformedInputExceptionbvc6h5ij0ias as MalformedInputException } from '../../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ValidateMark() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return ValidateMark;
}
var ValidateMark;
function get_LOGGER() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return LOGGER;
}
var LOGGER;
function addDefaultResponseValidation(_this__u8e3s4) {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  HttpResponseValidator(_this__u8e3s4, ($this$HttpResponseValidator) => {
    $this$HttpResponseValidator.f5q_1 = _this__u8e3s4.g5k_1;
    $this$HttpResponseValidator.g5q(addDefaultResponseValidation$lambda$slambda());
    return Unit_instance;
  });
}
var ResponseExceptionClass;
function ResponseException() {
  if (ResponseExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(response, cachedResponseText) {
        return new.target.m5q(response, cachedResponseText);
      }
      static m5q(response, cachedResponseText) {
        var $this = this.o('Bad response: ' + response.toString() + '. Text: "' + cachedResponseText + '"');
        captureStack($this, $this.l5q_1);
        $this.k5q_1 = response;
        return $this;
      }
    }
    initMetadataForClass($, 'ResponseException');
    ResponseExceptionClass = $;
  }
  return ResponseExceptionClass;
}
var RedirectResponseExceptionClass;
function RedirectResponseException() {
  if (RedirectResponseExceptionClass === VOID) {
    class $ extends ResponseException() {
      constructor(response, cachedResponseText) {
        return new.target.u5q(response, cachedResponseText);
      }
      static u5q(response, cachedResponseText) {
        var $this = this.m5q(response, cachedResponseText);
        captureStack($this, $this.t5q_1);
        $this.s5q_1 = 'Unhandled redirect: ' + response.v5l().o5l().w5l().f55_1 + ' ' + response.v5l().o5l().x5l().toString() + '. ' + ('Status: ' + response.e5m().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      r() {
        return this.s5q_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'RedirectResponseException');
    RedirectResponseExceptionClass = $;
  }
  return RedirectResponseExceptionClass;
}
var ClientRequestExceptionClass;
function ClientRequestException() {
  if (ClientRequestExceptionClass === VOID) {
    class $ extends ResponseException() {
      constructor(response, cachedResponseText) {
        return new.target.c5r(response, cachedResponseText);
      }
      static c5r(response, cachedResponseText) {
        var $this = this.m5q(response, cachedResponseText);
        captureStack($this, $this.b5r_1);
        $this.a5r_1 = 'Client request(' + response.v5l().o5l().w5l().f55_1 + ' ' + response.v5l().o5l().x5l().toString() + ') ' + ('invalid: ' + response.e5m().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      r() {
        return this.a5r_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'ClientRequestException');
    ClientRequestExceptionClass = $;
  }
  return ClientRequestExceptionClass;
}
var ServerResponseExceptionClass;
function ServerResponseException() {
  if (ServerResponseExceptionClass === VOID) {
    class $ extends ResponseException() {
      constructor(response, cachedResponseText) {
        return new.target.k5r(response, cachedResponseText);
      }
      static k5r(response, cachedResponseText) {
        var $this = this.m5q(response, cachedResponseText);
        captureStack($this, $this.j5r_1);
        $this.i5r_1 = 'Server error(' + response.v5l().o5l().w5l().f55_1 + ' ' + response.v5l().o5l().x5l().toString() + ': ' + (response.e5m().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      r() {
        return this.i5r_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'ServerResponseException');
    ServerResponseExceptionClass = $;
  }
  return ServerResponseExceptionClass;
}
function addDefaultResponseValidation$lambda$slambda() {
  return constructCallableReference((response, $completion) => orPromise($completion, function *($completion) {
    var expectSuccess = response.v5l().p5l().y4p(get_ExpectSuccessAttributeKey());
    var tmp;
    if (!expectSuccess) {
      // Inline function 'io.ktor.util.logging.trace' call
      var this_0 = get_LOGGER();
      if (get_isTraceEnabled(this_0)) {
        var tmp$ret$1 = 'Skipping default response validation for ' + response.v5l().o5l().x5l().toString();
        this_0.r4w(tmp$ret$1);
      }
      return Unit_instance;
    }
    var statusCode = response.e5m().t57_1;
    var originCall = response.v5l();
    var tmp_0;
    if (statusCode < 300 || originCall.p5l().a4q(get_ValidateMark())) {
      return Unit_instance;
    }
    // Inline function 'kotlin.apply' call
    var this_1 = yield* save(originCall, $completion);
    this_1.p5l().b4q(get_ValidateMark(), Unit_instance);
    var exceptionCall = this_1;
    var exceptionResponse = exceptionCall.q5j();
    var tmp_1;
    try {
      tmp_1 = yield* bodyAsText(exceptionResponse, VOID, $completion);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof MalformedInputException()) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = '<body failed decoding>';
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var exceptionResponseText = tmp_1;
    var exception = (300 <= statusCode ? statusCode <= 399 : false) ? RedirectResponseException().u5q(exceptionResponse, exceptionResponseText) : (400 <= statusCode ? statusCode <= 499 : false) ? ClientRequestException().c5r(exceptionResponse, exceptionResponseText) : (500 <= statusCode ? statusCode <= 599 : false) ? ServerResponseException().k5r(exceptionResponse, exceptionResponseText) : ResponseException().m5q(exceptionResponse, exceptionResponseText);
    // Inline function 'io.ktor.util.logging.trace' call
    var this_2 = get_LOGGER();
    if (get_isTraceEnabled(this_2)) {
      var tmp$ret$5 = 'Default response validation for ' + response.v5l().o5l().x5l().toString() + ' failed with exception';
      this_2.s4w(tmp$ret$5, exception);
    }
    throw exception;
  }), 1);
}
var properties_initialized_DefaultResponseValidation_kt_akvzqt;
function _init_properties_DefaultResponseValidation_kt__wcn8vr() {
  if (!properties_initialized_DefaultResponseValidation_kt_akvzqt) {
    properties_initialized_DefaultResponseValidation_kt_akvzqt = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ValidateMark';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(Unit());
    var tmp_0 = null instanceof Unit();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(Unit()), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp_0, tmp$ret$2);
    ValidateMark = new (AttributeKey())(name, tmp$ret$1);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.DefaultResponseValidation');
  }
}
//region block: exports
export {
  addDefaultResponseValidation as addDefaultResponseValidation1d06vtgr9flaj,
};
//endregion

//# sourceMappingURL=DefaultResponseValidation.mjs.map
